<template>
  <router-view />
</template>




<script>
import { mapFields } from "vuex-map-fields";
import i18n from "@/plugins/i18n";

export default {
  computed: {
    ...mapFields(["language"]),
  },
  watch: {
    language: function (newval) {
      console.log(newval);
      i18n.locale = newval;
    },
  },
};
</script>

<style>
</style>
<style>
input[type="email"],
input[type="password"],
input[type="search"],
input[type="tel"],
input[type="text"],
input[type="url"],
textarea {
  border: 0px solid #ccc !important;
}
</style>